import { getCurrentLanguage } from '.';
import { ILanguage } from '../interfaces/globalization.interfaces';

/**
 * setDocumentLanguage
 *
 * @summary Set language on the html document
 * <html lang="isoCode">
 * isoCode = da, en
 * @param supportedLanguages
 * @param languageId
 */
export const setDocumentLanguage = (supportedLanguages: ILanguage[], languageId: number): void => {
    const lang = getCurrentLanguage(supportedLanguages, languageId);
    if (lang) {
        document.documentElement.setAttribute('lang', lang.isoCode);
    }
};
